import { theme } from '@jadwalh/ui';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// create an interface for the props for the Input component
interface IInputProps {
  phoneInput?: boolean;
  langType?: string;
}
interface LabelProps {
  langType?: string;
}

export const Input = styled.input<IInputProps>`
  width: 100%;
  height: 53px;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  font-size: 13px;
  outline-color: transparent;
  padding: 20px 12px 0px 12px;

  border-bottom-left-radius: ${(props) =>
    props.phoneInput ? '0 !important' : '10px'};
  border-top-left-radius: ${(props) =>
    props.phoneInput ? '0 !important' : '10px'};
  text-align: ${(props) =>
    props.phoneInput || props.langType === 'en' ? 'left' : 'right'};

  &:focus {
    border: 1px solid ${theme.colours.white};
    padding: ${(props) =>
      props.phoneInput ? '20px 12px' : '20px 12px 0px 12px'};
  }

  &:not(:placeholder-shown) + span,
  &:focus + span {
    transform: translateY(-10px);
    font-size: 13px;
    color: #808080 !important;
  }

  &:not(:focus) + span {
    color: #808080 !important;
  }
  direction: ${(props) => (props.langType === 'en' ? 'ltr' : 'rtl')};
`;

export const Label = styled.span<LabelProps>`
  position: absolute;
  right: ${(props) => (props.langType === 'en' ? '' : '0')};
  left: ${(props) => (props.langType === 'en' ? '0' : '')};
  padding-right: ${(props) => (props.langType === 'en' ? '0' : '1.2rem')};
  padding-left: ${(props) => (props.langType === 'en' ? '1.2rem' : '0')};
  font-size: 13px;
  color: #7f8fa6;
  pointer-events: none;
  transition: 0.6s;
`;
